import { getLocalisedDateProperty } from '../utils/get-localised-date-property';
const getMeridiem = (params) => {
    return getLocalisedDateProperty({
        date: params.date,
        languageTag: params.languageTag,
        ianaTimeZoneName: params.ianaTimeZoneName,
        property: 'dayPeriod',
        format: 'numeric'
    });
};
/**
 * Returns the localised meridiem string in upper case: AM, PM
 * @hidden
 */
export const getMeridiemUpperCase = (params) => {
    return getMeridiem(params).toUpperCase();
};
/**
 * Returns the localised meridiem string in lower case: am, pm
 * @hidden
 */
export const getMeridiemLowerCase = (params) => {
    return getMeridiem(params).toLowerCase();
};
/**
 * (Not supported) Returns the 'full' meridiem string: a.m., p.m.
 * The MeridiemFull ("aa") format is supported by date-fns, but is not supported by the Intl API.
 * This method is here to communicate this breaking change to consumers of the i18n package.
 * @hidden
 */
export const getMeridiemFull = () => {
    throw new Error('MeridiemFull format ("aa") not supported');
};
//# sourceMappingURL=meridiem.js.map